import { z } from 'zod';
import {
  NegativeReturnedToWorkRationale,
  PositiveReturnedToWorkRationale,
  ReturnedToWorkRationale,
} from '../enums';
import { coerceBoolean } from '../../validation';

const returnedToWorkRationales: ReturnedToWorkRationale[] = [
  ...Object.values(PositiveReturnedToWorkRationale),
  ...Object.values(NegativeReturnedToWorkRationale),
];

export const EbpCaseReturnedToWorkSchema = z.object({
  returned: coerceBoolean(z.boolean()),
  // z.enum() cannot express this one: the positive and negative rationales
  // share the 'no_information_provided' value, and a value-keyed enum would
  // collapse the two into one
  rationale: z
    .custom<ReturnedToWorkRationale>(
      (value) =>
        returnedToWorkRationales.includes(value as ReturnedToWorkRationale),
      'Unknown returned to work rationale',
    )
    .meta({ type: 'string', enum: returnedToWorkRationales }),
  notes: z.string().optional(),
});

export type EbpCaseReturnedToWork = z.infer<typeof EbpCaseReturnedToWorkSchema>;
